module.exports = __webpack_public_path__ + "img/circle2.67757bf5.png";